<div class="modal-header py-2 inset-box-shadow">
  <h4 class="m-0 align-self-end">{{selectedItem ? 'Edit Item' : 'New Item'}}</h4>
  <button type="button" class="close" aria-label="Close"
          (click)="activeModal.dismiss('cancel')" id="closeModalBtn">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body custom-scrollbar">
  <form [formGroup]="itemForm">
    <div class="d-flex mb-3" style="width: 65%">
      <div class="col-9">
        <label>Item Name</label>
        <input formControlName="name" type="text" class="form-control" ngbAutoFocus>
      </div>
      <div class="col-2">
        <label>Quantity</label>
        <input formControlName="quantity" type="text" class="form-control text-center">
      </div>
      <div class="col-2">
        <label>Weight</label>
        <input formControlName="weight" type="text" class="form-control text-center">
      </div>
    </div>

    <div class="d-flex mb-3">
      <div class="col-5">
        <label>Damage</label>
        <input formControlName="damage" type="text" class="form-control">
      </div>
      <div class="d-flex flex-column col-3">
        <label>Damage Type</label>
        <div class="btn-group">
          <input formControlName="damageType" type="text" class="form-control dropdown-input">
          <div class="btn-group" ngbDropdown role="group" aria-label="Level">
            <button class="btn btn-outline-secondary" ngbDropdownToggle></button>
            <div class="dropdown-menu custom-scrollbar" ngbDropdownMenu>
              <button *ngFor="let type of damageTypes" ngbDropdownItem (click)="selectDamageType(type)">
                {{type}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex mb-3">
      <div class="d-flex flex-column col-3">
        <label>Type</label>
        <div class="btn-group">
          <input formControlName="type" type="text" class="form-control dropdown-input">
          <div class="btn-group" ngbDropdown role="group" aria-label="Level">
            <button class="btn btn-outline-secondary" ngbDropdownToggle></button>
            <div class="dropdown-menu custom-scrollbar" ngbDropdownMenu>
              <button *ngFor="let type of itemTypes" ngbDropdownItem (click)="selectType(type)">
                {{type}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <label>Item Rarity</label>
        <input formControlName="rarity" type="text" class="form-control">
      </div>
      <div class="col-3">
        <label>Range</label>
        <input formControlName="range" type="text" class="form-control">
      </div>
    </div>

    <div class="d-flex flex-column col-3 mb-3">
      <label>Properties</label>
      <div class="btn-group">
        <input #propInput type="text" class="form-control dropdown-input border m-0 pl-2"
               (keyup.enter)="$event.target.blur()"
               (focusout)="addChip(propInput.value); propInput.value=''"
               [matChipInputFor]="chipList">
        <div class="btn-group" ngbDropdown role="group" aria-label="Level">
          <button class="btn btn-outline-secondary" ngbDropdownToggle></button>
          <div class="dropdown-menu custom-scrollbar" ngbDropdownMenu>
            <button *ngFor="let prop of properties" ngbDropdownItem (click)="addChip(prop)">
              {{prop}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <mat-chip-list #chipList aria-label="Property selection">
        <span *ngIf="props" class="d-flex w-100 pl-3 mb-3">
        <mat-chip *ngFor="let prop of props" class="d-flex justify-content-between w-25">{{prop}}
          <fa-icon [icon]="faTimesCircle" (click)="removeChip(prop)" class=" text-muted clickable faTimesCircle">
          </fa-icon>
        </mat-chip>
        </span>
    </mat-chip-list>

    <div class="form-group ml-3 mr-4">
      <label>Description</label>
      <textarea id="description" rows="3" type="text-area" class="form-control" formControlName="description">
        </textarea>
    </div>
  </form>
</div>

<div class="modal-footer d-flex justify-content-between py-2">
  <button *ngIf="selectedItem" (click)="delete()"
          class="btn btn-sm btn-main-danger ml-4" id="deleteButton" type="button">Delete
  </button>
  <div *ngIf="!selectedItem"></div>
  <div class="mr-4">
    <button (click)="activeModal.close('cancel')" class="btn btn-sm btn-outline-secondary mr-2"
            id="cancelButton" type="button">Cancel
    </button>
    <button (click)="activeModal.close(save())" class="btn btn-sm btn-main" id="saveButton"
            [disabled]="!areChanges">{{selectedItem ? 'Save' : 'Add Item'}}
    </button>
  </div>
</div>
